const HOMEWORK_ACTIVITIES_LIST_PATH = "/clinician-portal/homework-activities";

function currentOrigin(): string {
  return typeof window === "undefined"
    ? "http://localhost"
    : window.location.origin;
}

export function safeHomeworkActivitiesReturnTo(value?: string | null): string {
  if (!value) return HOMEWORK_ACTIVITIES_LIST_PATH;

  try {
    const url = new URL(value, currentOrigin());
    if (
      url.origin !== currentOrigin() ||
      url.pathname !== HOMEWORK_ACTIVITIES_LIST_PATH
    ) {
      return HOMEWORK_ACTIVITIES_LIST_PATH;
    }

    url.searchParams.delete("clinicianCode");
    return `${url.pathname}${url.search}`;
  } catch {
    return HOMEWORK_ACTIVITIES_LIST_PATH;
  }
}

export function homeworkActivitiesReturnToFromSearch(search: string): string {
  return safeHomeworkActivitiesReturnTo(
    new URLSearchParams(search).get("returnTo"),
  );
}

export function withHomeworkActivitiesReturnTo(
  path: string,
  returnTo: string,
): string {
  const url = new URL(path, currentOrigin());
  url.searchParams.set("returnTo", safeHomeworkActivitiesReturnTo(returnTo));
  return `${url.pathname}${url.search}`;
}

export function currentHomeworkActivitiesListPath(search: string): string {
  return safeHomeworkActivitiesReturnTo(
    `${HOMEWORK_ACTIVITIES_LIST_PATH}${search}`,
  );
}
